import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {TransactionService} from "../../serverService/transactionService/TransactionService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {Skeleton} from "@mui/material";
import {convertCurrencyFormatPositiveNegative} from "../../util/numberConvertor";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {paymentStatus} from "./TransactionsList";
import {useAuthState} from "../../context/AuthContext";
import {
    convertCurrencyFormat,
    convertPersianDateToUniversalDate,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    RaikoLabel,
    raikoBreadCrumbItemGenerator,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined,
    RaikoSimpleInputOutlined,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    RaikoButtonSecondary, RaikoFlexFirstChildGrowOne
} from "@moeindal/base-raiko-panel-components";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator
} from "../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";

export const TransactionDetail = () => {

    const {id: transactionId = -1} = useParams()
    const {fundID} = useAuthState()
    const service = new TransactionService()

    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    const [transactionInfo, setTransactionInfo] = useState()
    const [loading, setLoading] = useState(true);
    const [installmentsList, setInstallmentsList] = useState([]);
    const [depositAccountList, setDepositAccountList] = useState([]);
    const [otherPaymentList, setOtherPaymentList] = useState([]);

    useEffect(() => {
        if (transactionId && transactionId > 0) {
            getDataFromServer();
        }
    }, [transactionId]);

    function getDataFromServer() {
        setLoading(true)
        service.getTransactionInformation(fundID, transactionId)
            .then(response => {
                setTransactionInfo(response)
                setInstallmentsList(response.installmentActions)
                setDepositAccountList(response.depositAccountActions)
                setOtherPaymentList(response.otherPaymentActions)
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            setLoading(false)
        })
    }


    const [pageTitle, setPAgeTitle] = useState("")
    const navigate = useNavigate()

    function ignoreOnChange() {
        //
    }

    return (
        <>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb className={css`flex-grow: 1;
                            gap: .5rem;`} breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.TransactionsList.name,
                                RouteHelper.TransactionsList.globalUrl
                            )
                        ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1);
                            }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <RaikoBaseCardContainer>
                        <div className={css`
                            display: flex;
                            flex-direction: row;
                            width: 100%;
                            justify-content: space-between;
                            align-items: center;
                        `}>
                            <RaikoLabel text={"وضعیت پرداخت"}/>
                            {
                                loading ?
                                    <Skeleton
                                        variant="rectangular"
                                        className={css`
                                            padding: 16px;
                                            min-height: 40px;
                                            width: 72px;`}
                                    /> :
                                    transactionInfo.status === paymentStatus.SUCCESS.id ?
                                        <RaikoCustomSimpleChip
                                            title={paymentStatus.SUCCESS.name}
                                            type={RaikoChipTypes.success}/> :
                                        transactionInfo.status === paymentStatus.UN_SUCCESS.id ?
                                            <RaikoCustomSimpleChip
                                                title={paymentStatus.UN_SUCCESS.name}
                                                type={RaikoChipTypes.error}/> :
                                            <RaikoCustomSimpleChip
                                                title={paymentStatus.AWAITING_FOR_PAYMENT.name}
                                                type={RaikoChipTypes.warning}/>


                            }
                        </div>

                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer title={"جزئیات تراکنش"}>
                            {
                                !loading && transactionInfo ?
                                    <RaikoGridThreeColumn>
                                        <RaikoSimpleInputOutlined
                                            labelText={"مبلغ (ریال)"}
                                            disabled setValue={ignoreOnChange}
                                            value={convertCurrencyFormatPositiveNegative(transactionInfo.amount)}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"تاریخ"}
                                            disabled setValue={ignoreOnChange}
                                            value={convertUniversalDateToPersianDate(transactionInfo.createdAtDate)}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"زمان"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.createdAtPersianTime}/>
                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه پرداخت"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.serial}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه درگاه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.gatewaySerial}/>
                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه داخلی درگاه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.paymentGatewayId}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"عنوان داخلی درگاه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.paymentGatewayTitle}/>
                                        <RaikoSimpleInputOutlined
                                            labelText={"نوع داخلی درگاه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.paymentGatewayType}/>
                                    </RaikoGridThreeColumn>
                                    : <RaikoGridThreeColumn>
                                        {
                                            [...Array(6)].map(item => {
                                                return <Skeleton
                                                    key={item}
                                                    variant="rectangular"
                                                    className={css`
                                                        padding: 16px;
                                                        min-height: 50px;
                                                        width: 100%;`}
                                                />
                                            })
                                        }
                                    </RaikoGridThreeColumn>


                            }

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جزئیات پرداخت کننده"}
                            hasActionButton
                            actionButtonTitle={"جزئیات کاربر"}
                            actionButtonOnclick={_ => {
                                if (transactionInfo && transactionInfo.payerId) {
                                    navigate(RouteHelper.UserInformation.globalUrl.replace(":id", transactionInfo.payerId))
                                }
                            }}
                        >
                            {
                                !loading && transactionInfo ?
                                    <RaikoGridThreeColumn>
                                        <RaikoSimpleInputOutlined
                                            labelText={"شناسه داخلی کاربر"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.id}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"نام"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerFirstName}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"نام خانوادگی"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerLastName}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"شماره همراه"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerPhoneNumber}/>

                                        <RaikoSimpleInputOutlined
                                            labelText={"کد ملی"}
                                            disabled setValue={ignoreOnChange}
                                            value={transactionInfo.payerNationalCode}/>
                                    </RaikoGridThreeColumn>
                                    : <RaikoGridOneColumn>
                                        {
                                            [...Array(6)].map(item => {
                                                return <Skeleton
                                                    key={item}
                                                    variant="rectangular"
                                                    className={css`
                                                        padding: 16px;
                                                        min-height: 50px;
                                                        width: 100%;`}
                                                />
                                            })
                                        }
                                    </RaikoGridOneColumn>


                            }

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جزئیات خطا"}
                        >
                            {
                                !loading && transactionInfo ?
                                    <RaikoGridOneColumn>
                                        <RaikoSimpleMultiLineInputOutlined
                                            labelText={"متن خطا"}
                                            setValue={ignoreOnChange}
                                            disabled
                                            value={transactionInfo.errorMessage ? transactionInfo.errorMessage : "بدون خطا"}
                                        />
                                    </RaikoGridOneColumn>
                                    : <RaikoGridOneColumn>
                                        <Skeleton
                                            variant="rectangular"
                                            className={css`
                                                padding: 16px;
                                                min-height: 50px;
                                                width: 100%;`}
                                        />
                                    </RaikoGridOneColumn>


                            }

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>


                    {!loading && installmentsList && installmentsList.length > 0 ?
                        <RaikoBaseCardContainer>
                            <RaikoGridOneColumn>
                                <RaikoSectionContainer
                                    title={"پرداخت اقساط"}
                                    subTitle={installmentsList.length > 0 ? `${installmentsList.length} تراکنش ثبت شده ` : ""}
                                >
                                    <RaikoGridOneColumn>
                                        {
                                            installmentsList.map((item, index) => {
                                                return <RaikoCardInfoTypeOne
                                                    titleLabel={"نام و نام خانوادگی"}
                                                    title={`${item.ownerLoanFirstName} ${item.ownerLoanLastName}`}
                                                    items={[
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "شناسه",
                                                            index + 1
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "شناسه وام",
                                                            item.loanId
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "شماره حساب",
                                                            item.depositAccountNumber
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "مبلغ وام (ریال)",
                                                            convertCurrencyFormat(item.loanAmount)
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "شماره قسط",
                                                            item.installmentNumber
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "کد ملی",
                                                            item.ownerLoanNationalCode
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "سر رسید قسط",
                                                            convertUniversalDateToPersianDate(item.installmentPaymentDate)
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "مبلغ قابل پرداخت (ریال)",
                                                            convertCurrencyFormat(item.amount)
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "مبلغ پرداخت شده (ریال)",
                                                            convertCurrencyFormat(item.installmentPayableAmount)
                                                        ),
                                                    ]}


                                                />
                                            })}
                                    </RaikoGridOneColumn>
                                </RaikoSectionContainer>
                            </RaikoGridOneColumn>
                        </RaikoBaseCardContainer>
                        : <></>
                    }
                    {
                        !loading && depositAccountList && depositAccountList.length > 0 ?
                            <RaikoBaseCardContainer>
                                <RaikoGridOneColumn>
                                    <RaikoSectionContainer
                                        title={"واریز ماهیانه"}
                                        subTitle={depositAccountList.length > 0 ? `${depositAccountList.length} تراکنش ثبت شده ` : ""}
                                    >
                                        <RaikoGridOneColumn>
                                            {depositAccountList.map((item, index) => {
                                                return <RaikoCardInfoTypeOne
                                                    titleLabel={"نام و نام خانوادگی"}
                                                    title={`${item.ownerFirstName} ${item.ownerLastName}`}
                                                    items={[
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "شناسه",
                                                            index + 1
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "مبلغ (ریال)",
                                                            convertCurrencyFormat(item.amount)
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "شماره حساب",
                                                            item.depositAccountNumber
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "کد ملی",
                                                            item.ownerNationalCode
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "تاریخ",
                                                            convertUniversalDateToPersianDate(item.date)
                                                        )
                                                    ]}
                                                />
                                            })}
                                        </RaikoGridOneColumn>

                                    </RaikoSectionContainer>

                                </RaikoGridOneColumn>
                            </RaikoBaseCardContainer> : <></>
                    }
                    {
                        !loading && otherPaymentList && otherPaymentList.length > 0 ?
                            <RaikoBaseCardContainer>
                                <RaikoGridOneColumn>
                                    <RaikoSectionContainer
                                        title={"سایر پرداختی ها"}
                                        subTitle={otherPaymentList.length > 0 ? `${otherPaymentList.length} تراکنش ثبت شده ` : ""}
                                    >
                                        <RaikoGridOneColumn>
                                            {otherPaymentList.map((item, index) => {
                                                return <RaikoCardInfoTypeOne
                                                    titleLabel={"نام و نام خانوادگی"}
                                                    title={`${item.ownerFirstName} ${item.ownerLastName}`}
                                                    items={[
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "شناسه",
                                                            index + 1
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "عنوان خرید",
                                                            item.otherPaymentTitle
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "مبلغ کل (ریال)",
                                                            convertCurrencyFormat(item.amount)
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "تاریخ شروع",
                                                            convertPersianDateToUniversalDate(item.otherPaymentStartDate)
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "تاریخ پایان",
                                                            convertPersianDateToUniversalDate(item.otherPaymentEndDate)
                                                        ),
                                                        RaikoCardInfoTypeOneItemGenerator(
                                                            "تاریخ خرید",
                                                            convertPersianDateToUniversalDate(item.date)
                                                        )
                                                    ]}
                                                />
                                            })}
                                        </RaikoGridOneColumn>
                                    </RaikoSectionContainer>

                                </RaikoGridOneColumn>
                            </RaikoBaseCardContainer> : <></>
                    }

                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>


        // <>
        //     <RaikoGridTwoColumn>
        //         <RaikoReadOnlyOutlinedInput labelText={"شماره سریال"} value={serial}/>
        //         <RaikoReadOnlyOutlinedInput labelText={"سریال درگاه"} value={gatewaySerial}/>
        //         <RaikoReadOnlyOutlinedInput labelText={"ip"} value={ip}/>
        //     </RaikoGridTwoColumn>
        // </>
    )
}